class IconList {
    constructor(domElement) {
        this.domElement = domElement || null;

        this.bindEvents();
    }

    bindEvents() {
    }
}

export default IconList;
